// extracted by mini-css-extract-plugin
export default {"container":"UserSearch_container__RT-7a","tableContainer":"UserSearch_tableContainer__WzJO4","tableHeader":"UserSearch_tableHeader__dY5Uj","tableRow":"UserSearch_tableRow__0zJxq"};